import axios from 'axios';

export const requestPremiumPaymentIntent = (payload: any): Promise<any> => {
  return axios.post('v1/premium/web/purchases', payload.toJSON());
};

export const requestPremiumPaymentVerification = async (purchaseID: string) => {
  try {
    await axios.post(`v1/premium/web/purchases/${purchaseID}/confirm`);
    return 200;
  } catch (e: any) {
    return e;
  }
};
